import {
  EMPTY,
  Observable,
  fromEvent,
  map,
  merge,
  of,
  race,
  switchMap,
  tap,
} from 'rxjs';

const userActivity$ = (document: Document) =>
  merge(
    fromEvent(document, 'mousemove'),
    fromEvent(document, 'touchmove'),
    fromEvent(document, 'click'),
    fromEvent(window, 'scroll'),
  );

export type TokenExpirationAction = 'logout' | 'refresh';

export function monitorTokenExpiration(
  login$: Observable<number>,
  logout$: Observable<void>,
  document: Document,
): Observable<TokenExpirationAction> {
  return merge(
    login$.pipe(
      switchMap((expirationTime: number) => {
        if (expirationTime === 0) return EMPTY;
        return race([
          refreshTokenIfActive(expirationTime, document),
          logoutWhenNoAction(expirationTime),
        ]);
      }),
    ),
    logout$.pipe(map(() => undefined)),
  ).pipe(
    switchMap((value) => {
      if (!value) {
        return EMPTY;
      }
      return of(value);
    }),
  );
}

const refreshTokenIfActive = (expirationTime: number, document: Document) => {
  return tokenExpire$(expirationTime, 10).pipe(
    switchMap(() => userActivity$(document)),
    map(() => 'refresh' as TokenExpirationAction),
  );
};

const logoutWhenNoAction = (expirationTime: number) => {
  return tokenExpire$(expirationTime).pipe(
    map(() => 'logout' as TokenExpirationAction),
  );
};

const tokenExpire$ = (expirationTime: number, offsetInMin?: number) => {
  const worker = new Worker('assets/scripts/expiryWorker.js', {
    type: 'module',
  });
  worker.postMessage({ expirationTime, offsetInMin });
  const message$ = fromEvent<MessageEvent>(worker, 'message');
  return message$.pipe(tap(() => worker.terminate()));
};
